import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TProductKeyDM from './TProductKeyDM'
import TArticleDM from './TArticleDM'

export default class TLoyaltyProgramDefinitionDM extends Data {
	public static className = 'TLoyaltyProgramDefinitionDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	SequenceNumber?: number
	LoyaltyProgramId?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TProductKeyDM)
	ProductKeyId?: TProductKeyDM
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}